import client from "../client";

const getClients = () => client.get<any>(`/clients`);

const getByIdWithPaymentsAndTrainingsAndHolidays = (id: number) =>
  client.get<any>(`/clients/all/${id}`);

const getAll = () => client.get<any>(`/clients/all`);

const registerClient = (props: any) => client.post<any>(`/clients`, props);

const updateClient = (props: any, id: number) =>
  client.patch<any>(`/clients/${id}`, props);

const deleteClient = (id: number) => client.delete<any>(`/clients/${id}`);

const stop = (props: any) => client.post<any>(`/clients/stop`, props);

const cancel = (props: any) => client.post<any>(`/clients/cancel`, props);

const stopAll = (props: any) => client.post<any>(`/clients/stop-all`, props);

const getMe = () => client.get<any>(`/clients/get/me`);

const getByIdWithBookings = (id: number, location: string) =>
  client.get<any>(`/clients/get/${id}/${location}`);

const findInactive = () => client.get<any>(`/clients/get/inactive`);

const findDebtors = () => client.get<any>(`/clients/get/debtors`);

const clientsApi = {
  getClients,
  getByIdWithPaymentsAndTrainingsAndHolidays,
  getAll,
  registerClient,
  updateClient,
  deleteClient,
  stop,
  cancel,
  stopAll,
  getMe,
  getByIdWithBookings,
  findInactive,
  findDebtors,
};
export default clientsApi;
